
import { Component } from '@angular/core'; 
import { VehicleService } from '../_Services/vehicle.service';
import { CommonService } from '../_Services/common.service';

import { Router, ActivatedRoute } from '@angular/router';  

@Component({
  templateUrl: 'viewvehicle.component.html'
})
export class ViewvehicleComponent {

    vehicle = [];   
    debt = []; 

    service = [];

	constructor(private vehicleService: VehicleService, private route:ActivatedRoute) { }
 

	ngOnInit() { 
		var id = this.route.snapshot.params['id'];
		this.vehicleService.getVehicle(id).subscribe(result => {
                console.log(result);
                this.vehicle = result.debt.Vehicle; 
                this.debt = result.debt.DebtInformation; 
                this.service = result.finance.FinanceService; 
            });  
	}
}


// WEBPACK FOOTER //
// ./src/app/debts/viewvehicle.component.ts